import $ from 'jquery';
import _ from 'lodash';
import Popup from 'popup-window';
import {getEbayAccounts} from '../../MyAccount/ViewDesigns/helpers/preferencesHelper';
import safeStore from '../../App/safeStore';
import {setEBayAccounts} from '../../MyAccount/ViewDesigns/redux/modules/accountPage';
import {updateUserData} from '../../MyAccount/ViewDesigns/redux/modules/user';
import ErrorDialog from '../components/Dialogs/ErrorDialog/ErrorDialog';
import InfoDialog from '../components/Dialogs/InfoDialog/InfoDialog';
import {PlanAndBilling} from '../../MyAccount/AccountPage/AccountPageSectionsData';
import {browserHistory} from 'react-router';
import * as React from 'react';
import CrownIcon from 'mdi-material-ui/Crown';

let ebayWindow = null;
let fetched = false;

export const EBAY_CONNECT_STATUS = {
  SUCCESS: 'success',
  ERROR: 'error',
  DUPLICATE: 'duplicate',
  CANCEL: 'cancel',
  SWITCHED: 'switched',
  LIMIT: 'limit',
};

function init() {
  ebayWindow = null;
  fetched = false;
}

function fetchToken(callback, calledFrom) {
  if (fetched) {
    return;
  }
  $.get('/ebay/check-token-fetched', {calledFrom: calledFrom}).success(data => {
    let status;
    if (_.isEmpty(data) || _.isEmpty(data.fetched)) {
      status = EBAY_CONNECT_STATUS.CANCEL;
    } else {
      status = data.fetched;
      if (status === EBAY_CONNECT_STATUS.SUCCESS || status === EBAY_CONNECT_STATUS.SWITCHED) {
        _.defer(() => {
          window.analytics.track('Connect to eBay - Connected - Client');
          window.fbq('trackCustom', 'Connected');
        });
      }
    }
    if (fetched === false && !_.isEmpty(data.fetched)) {
      fetched = true;
      if (ebayWindow) {
        ebayWindow.close();
      }
    }
    window.focus();
    if (callback) {
      callback(status, data);
    }
  });
}

export function launchAuth(callback, ruparams, calledFrom) {
  init();
  const ruName = window.ruName || window.___data.settings.ruName;
  const appName = window.appName || window.___data.settings.appName;
  let url;
  ruparams = ruparams ? '&state=' + encodeURIComponent(ruparams) : '';
  if (window.ebayProduction || window.___data.settings.ebayProduction) {
    url =
      'https://auth.ebay.com/oauth2/authorize?client_id=' +
      appName +
      '&response_type=code&redirect_uri=' +
      ruName +
      '&scope=https://api.ebay.com/oauth/api_scope https://api.ebay.com/oauth/api_scope/sell.marketing.readonly https://api.ebay.com/oauth/api_scope/sell.marketing https://api.ebay.com/oauth/api_scope/sell.inventory.readonly https://api.ebay.com/oauth/api_scope/sell.inventory https://api.ebay.com/oauth/api_scope/sell.account.readonly https://api.ebay.com/oauth/api_scope/sell.account https://api.ebay.com/oauth/api_scope/sell.fulfillment.readonly https://api.ebay.com/oauth/api_scope/sell.fulfillment https://api.ebay.com/oauth/api_scope/sell.analytics.readonly';
  } else {
    url =
      'https://auth.sandbox.ebay.com/oauth2/authorize?client_id=' +
      appName +
      '&response_type=code&redirect_uri=' +
      ruName +
      '&scope=https://api.ebay.com/oauth/api_scope https://api.ebay.com/oauth/api_scope/buy.order.readonly https://api.ebay.com/oauth/api_scope/buy.guest.order https://api.ebay.com/oauth/api_scope/sell.marketing.readonly https://api.ebay.com/oauth/api_scope/sell.marketing https://api.ebay.com/oauth/api_scope/sell.inventory.readonly https://api.ebay.com/oauth/api_scope/sell.inventory https://api.ebay.com/oauth/api_scope/sell.account.readonly https://api.ebay.com/oauth/api_scope/sell.account https://api.ebay.com/oauth/api_scope/sell.fulfillment.readonly https://api.ebay.com/oauth/api_scope/sell.fulfillment https://api.ebay.com/oauth/api_scope/sell.analytics.readonly https://api.ebay.com/oauth/api_scope/sell.marketplace.insights.readonly https://api.ebay.com/oauth/api_scope/commerce.catalog.readonly https://api.ebay.com/oauth/api_scope/buy.shopping.cart';
  }
  url = url + '&prompt=login' + ruparams;
  console.log('Opening ebay with url:', url);
  ebayWindow = new Popup('', {name: 'eBay Connect Window', height: 620, width: 1000});
  ebayWindow.closed(() => {
    fetchToken(callback, calledFrom);
  });
  ebayWindow.open();
  ebayWindow.win.location.href = url;
}

export function handleLimitReached(referenceTransactionEnabled = true) {
  InfoDialog.info({
    title: 'Accounts Limit Reached',
    message: (
      <div>
        <div style={{fontWeight: 300, fontSize: 24, marginBottom: 15}}>Get more accounts connected!</div>
        <div>
          You have reached your plan’s limit for allowed accounts.
          <br />
          Select a relevant plan to add more accounts,
          <br />
          increase your listing limit, plus a host of other great features.
        </div>
      </div>
    ),
    buttonLabel: 'Got it, select a plan',
    icon: <CrownIcon color="white" />,
    action: () => {
      browserHistory.push({pathname: PlanAndBilling.getRoute({referenceTransactionEnabled})});
    },
  });
}

export function handleAuthResponse(status, referenceTransactionEnabled = true) {
  switch (status) {
    case EBAY_CONNECT_STATUS.SUCCESS:
    case EBAY_CONNECT_STATUS.SWITCHED:
      getEbayAccounts().then(result => {
        if (result.success) {
          safeStore().dispatch(setEBayAccounts(result.eBayAccounts));
          safeStore().dispatch(updateUserData(result.user));
        }
      });
      break;
    case EBAY_CONNECT_STATUS.LIMIT:
      handleLimitReached(referenceTransactionEnabled);
      break;
    case EBAY_CONNECT_STATUS.ERROR:
      ErrorDialog.error({
        errorMessage: <div>Something went wrong, eBay Authentication failed.</div>,
        errorTitle: 'Error Adding eBay Account',
        retryButtonLabel: 'OK, TRY AGAIN',
        onRetryButtonClick: launchAuth,
      });
      break;
    case EBAY_CONNECT_STATUS.DUPLICATE:
      ErrorDialog.error({
        errorMessage: <div>This eBay account is already connected to a different CrazyLister account</div>,
        errorTitle: 'eBay Account In Use',
        retryButtonLabel: 'TRY WITH A DIFFERENT ACCOUNT',
        onRetryButtonClick: launchAuth,
      });
      break;
    default:
      break;
  }
}
